export var StoryVisibility;
(function (StoryVisibility) {
    StoryVisibility["Visible"] = "visible";
    StoryVisibility["Hidden"] = "hidden";
    StoryVisibility["Deleted"] = "deleted";
})(StoryVisibility || (StoryVisibility = {}));
export var CompletionProvider;
(function (CompletionProvider) {
    CompletionProvider[CompletionProvider["OpenAi"] = 0] = "OpenAi";
    CompletionProvider[CompletionProvider["Anthropic"] = 1] = "Anthropic";
})(CompletionProvider || (CompletionProvider = {}));
export var MediaProvider;
(function (MediaProvider) {
    MediaProvider[MediaProvider["Google"] = 0] = "Google";
    MediaProvider[MediaProvider["ElevenLabs"] = 1] = "ElevenLabs";
})(MediaProvider || (MediaProvider = {}));
//# sourceMappingURL=stories.js.map